module.exports = __webpack_public_path__ + "img/error.fff9931a.png";